export default __webpack_public_path__ + "static/vision-ph-map-8d7b75eb58bf7071c75f1dd2a5aa24be.jpg";